import React, { createContext, useContext, useState, useCallback } from 'react';

const AlertContext = createContext();

export const useAlert = () => {
    const context = useContext(AlertContext);
    if (!context) {
        throw new Error('useAlert must be used within an AlertProvider');
    }
    return context;
};

export const AlertProvider = ({ children }) => {
    const [alertState, setAlertState] = useState({
        isOpen: false,
        message: '',
        type: 'info', // 'info', 'confirm', 'prompt'
        onConfirm: null,
        onCancel: null
    });

    const showAlert = useCallback((message, options = {}) => {
        const { type = 'info', onConfirm = null, onCancel = null } = 
            typeof options === 'function' ? { onConfirm: options } : options;
            
        setAlertState({
            isOpen: true,
            message,
            type,
            onConfirm,
            onCancel
        });
    }, []);

    const hideAlert = useCallback(() => {
        setAlertState(prev => ({ ...prev, isOpen: false }));
    }, []);

    return (
        <AlertContext.Provider value={{ showAlert, hideAlert, alertState }}>
            {children}
        </AlertContext.Provider>
    );
};
